export default "__VITE_ASSET__C960ACbI__"